/**
 * 区分 formStatus（forms.form_status）
 * 出典：要件書 2.3。archived（アーカイブ）は旧 PCRM に合わせて復元（273）。外部公開は published のときだけ。
 */
export const FORM_STATUS_VALUES = ['unpublished', 'published', 'archived'] as const;

export type FormStatus = (typeof FORM_STATUS_VALUES)[number];

export const FORM_STATUS_LABELS: Readonly<Record<FormStatus, string>> = {
  unpublished: '非公開',
  published: '公開',
  archived: 'アーカイブ',
};
